import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { colors } from "utils/styles";

export default function LoadingSpinner(props) {
	const { color = "green", message = "Loading..." } = props;
	return (
		<>
			<span className="">{message}</span>
			<div className="spinner-container">
				<Spinner animation="border" role="status" aria-hidden="true">
					<span className="visually-hidden">{message}</span>
				</Spinner>
				<style global jsx>{`
					.spinner-container {
						width: 100%;
						height: 300px;
						display: flex;
						justify-content: center;
						align-items: center;
					}
					.spinner-border {
						color: ${colors[color]};
						height: 60px;
						width: 60px;
					}
				`}</style>
			</div>
		</>
	);
}
